(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('modulesDao', ["$q", "http", "appsConverter", "modulesConverter", "appStoreConverter", "cloudAppsConverter", "securityMatrixConverter", "scriptConverter", "policyDao", "cloudAppsDashboardConverter", "modulesStatsConverter", "moduleLabelsConverter", "feature", "configDao", "entityInfoConverter", "servicenowAccountsConverter", "modulePropsToOptions", "saasStatusReportBuilder", "licensesDao", "modals", "$rootScope", "dualAppHelper", function ($q, http, appsConverter, modulesConverter, appStoreConverter, cloudAppsConverter, securityMatrixConverter, scriptConverter, policyDao, cloudAppsDashboardConverter, modulesStatsConverter, moduleLabelsConverter, feature, configDao, entityInfoConverter, servicenowAccountsConverter, modulePropsToOptions, saasStatusReportBuilder, licensesDao, modals, $rootScope, dualAppHelper) {
        var appApiUrl = '/api/v1/apps';
        var categoriesApiUrl = '/api/v1/apps/categories';
        var appStoreOrder = {
            categorySort: 'appStoreOrder',
            moduleSort: 'app_store_order'
        };
        var securityStackOrder = {
            categorySort: 'securityStackOrder',
            moduleSort: 'security_stack_order'
        };
        var appsResultCache;
        $rootScope.$on('groupFilterPopup', function (event, data) {
            var saas = data.saas;
            modulesDao.displayUserGroupsFilterModal(saas);
        });
        function getOnlyAppsMap() {
            return configDao.getLocalConfJson('app_store_apps').converter(function (onlyAppsConfig) {
                var onlyApps = onlyAppsConfig && _(onlyAppsConfig).chain().map(function (category, categoryName) {
                    return category.apps;
                }).flatten().uniq().compact().value();
                if (!onlyApps || onlyApps.length < 1) {
                    onlyApps = null;
                } else {
                    onlyApps = _(onlyApps).chain().map(function (appName) {
                        return [
                            appName,
                            true
                        ];
                    }).object().value();
                }
                return $q.when(onlyApps);
            });
        }
        function getTopCategories() {
            return http.get('/api/v1/apps/top_categories').converter(function (input) {
                _(input.data).each(function (row) {
                    if (row.name === 'shadow_it' && feature.sonicwallTheme) {
                        row.label = 'Shadow SaaS';
                    }
                });
                return $q.when(input);
            }).onRequestFail(function () {
                return $q.when({ data: [] });
            });
        }
        function getCategories() {
            return http.get(categoriesApiUrl).converter(function (input) {
                _(input.data).each(function (row) {
                    if (row.type === 'shadow_it' && feature.sonicwallTheme) {
                        row.categoryLongName = 'Shadow SaaS';
                        row.categoryName = 'Shadow SaaS';
                    }
                });
                return $q.when(input);
            }).onRequestFail(function () {
                return $q.when({ data: [] });
            });
        }
        // for group filter feature
        // TODO: Make it not a patch (it's patchy now)
        var saasToLabelDict = {
            'office365_emails': 'Office 365 Outlook',
            'office365_onedrive': 'Office 365 Onedrive',
            'office365_sharepoint': 'Office 365 Sharepoint',
            'google_mail': 'Gmail',
            'google_drive': 'Google Drive'
        };
        var showGroupsPopupForList = [
            'office365_emails',
            'google_mail'
        ];
        var GSuiteConfigContextSaasList = [
            'google_mail',
            'google_drive'
        ];
        var OfficeSuiteConfigContextSaasList = [
            'office365_emails',
            'office365_onedrive',
            'office365_sharepoint'
        ];
        function checkGroupFilter(operation, appName) {
            return feature.init(true, true).then(function () {
                if (feature.driveGroupsFilterPopup) {
                    showGroupsPopupForList.push('office365_onedrive', 'office365_sharepoint');
                }
                if (operation === 'start') {
                    if (showGroupsPopupForList.includes(appName)) {
                        var SuitContextConfigModule = '';
                        if (OfficeSuiteConfigContextSaasList.includes(appName)) {
                            SuitContextConfigModule = 'office365_auth';
                        } else if (GSuiteConfigContextSaasList.includes(appName)) {
                            SuitContextConfigModule = 'google_server';
                        } else {
                            return $q.when();
                        }
                        return modulesDao.retrieveConfig(SuitContextConfigModule).then(function (data) {
                            // here we chack if pop up filter was already shown for that suit.
                            var wasGroupFilterPopupShown = data.data && data.data.groupFilterPopupShown && data.data.groupFilterPopupShown.value;
                            if (wasGroupFilterPopupShown) {
                                return startBootstrap(appName);
                            }
                            return modulesDao.retrieveConfig(appName).then(function (data) {
                                var start_bootstrap = data.data && data.data.start_bootstrap && data.data.start_bootstrap.value;
                                if (!start_bootstrap) {
                                    if (feature.checkpointTheme || feature.sonicwallTheme) {
                                        window.localStorage.setItem('selectGroupsStage', appName);
                                        return displayUserGroupsFilterModal(appName, SuitContextConfigModule);
                                    } else {
                                        return startBootstrap(appName);
                                    }
                                }
                                return $q.when();
                            });
                        }, function (data) {
                            // fail
                            return modulesDao.retrieveConfig(appName).then(function (data) {
                                var start_bootstrap = data.data && data.data.start_bootstrap && data.data.start_bootstrap.value;
                                if (!start_bootstrap) {
                                    if (feature.checkpointTheme || feature.sonicwallTheme) {
                                        window.localStorage.setItem('selectGroupsStage', appName);
                                        return displayUserGroupsFilterModal(appName, SuitContextConfigModule);
                                    } else {
                                        return startBootstrap(appName);
                                    }
                                }
                                return $q.when();
                            });
                        });
                    } else {
                        return startBootstrap(appName);
                    }
                }
                return $q.when();
            });
        }
        function displayUserGroupsFilterModal(currentSaaS, SuitContextConfigModule, retry) {
            var licensesCount = 0;
            return $q.all([
                licensesDao.getLicenses(),
                modulesDao.retrieveConfig(currentSaaS, 'group_filter')
            ]).then(function (responses) {
                var licenses = responses[0].data.data;
                var groups = responses[1].data && responses[1].data.group_filter && responses[1].data.group_filter.value && responses[1].data.group_filter.value.ids;
                groups = groups || [];
                var groupsMails = [];
                if (groups.length) {
                    groupsMails = groups.map(function (group) {
                        return group.mail || group.email;
                    });
                }
                if (_(licenses).isArray()) {
                    licenses.forEach(function (license) {
                        if (license.saas == currentSaaS) {
                            licensesCount = license.seats;
                        }
                    });
                }
                var selectionNote = '* Group must have an associated email address.';
                return modals.params([{
                        lastPage: true,
                        hideDefaultButton: true,
                        label: 'Please select filter scope',
                        params: [
                            {
                                id: 'user_selection_mode',
                                type: 'radio-group',
                                buttons: [
                                    {
                                        label: 'All organization',
                                        value: 'all'
                                    },
                                    {
                                        label: 'Specific group',
                                        value: 'filter',
                                        tooltip: 'Scanning and Enforcement will be reduced to the specified group'
                                    }
                                ],
                                data: groups.length ? 'filter' : 'all',
                                validation: { required: { message: 'Please choose one' } }
                            },
                            currentSaaS.includes('office') ? {
                                type: 'message',
                                message: 'Specify an Office 365 Group, Distribution List or Mail Enabled Security Group',
                                enabled: [{
                                        param: 'user_selection_mode',
                                        equal: 'filter'
                                    }]
                            } : {},
                            {
                                id: 'user_selection_specific_groups_list',
                                type: 'list',
                                enabled: [{
                                        param: 'user_selection_mode',
                                        equal: 'filter'
                                    }],
                                data: groupsMails,
                                validation: {
                                    required: { message: 'User groups list is required' },
                                    maxLength: currentSaaS.includes('office') ? {
                                        value: 1,
                                        message: 'Office 365 can not contain more than 1 group filter'
                                    } : { value: 1000 }
                                }
                            },
                            {
                                type: 'message',
                                message: selectionNote
                            }
                        ]
                    }], saasToLabelDict[currentSaaS] + ' - Group Selection').then(function (data) {
                    if (currentSaaS === 'google_mail') {
                        window.localStorage.removeItem('dualAuthStarted');
                    }
                    if (data.user_selection_mode == 'all') {
                        return http.put('/api/v1/apps/' + currentSaaS + '/config').body({ group_filter: null }).then(function (data) {
                            return startBootstrap(currentSaaS, SuitContextConfigModule, retry);
                        });
                    } else {
                        var groups = data.user_selection_specific_groups_list;
                        var promises = [];
                        groups.forEach(function (group) {
                            promises.push(http.post('/api/v1/' + currentSaaS + '/group/verify').body({ name: group }));
                        });
                        return $q.all(promises).then(function (responses) {
                            var filterGroupIds = [];
                            responses.forEach(function (response) {
                                filterGroupIds.push(response.data);
                            });
                            return http.put('/api/v1/apps/' + currentSaaS + '/config').body({
                                group_filter: {
                                    ids: filterGroupIds,
                                    exclude: false
                                }
                            }).then(function (data) {
                                // Remove user group selection from local storage
                                return startBootstrap(currentSaaS, SuitContextConfigModule, retry);
                            });
                        }, function (error) {
                            return modals.alert('Not all groups exists, please insert a valid list of groups', { title: 'Invalid group list' }).then(function () {
                                return displayUserGroupsFilterModal(currentSaaS, undefined, retry);
                            });
                        });
                    }
                }, function () {
                    return startBootstrap(currentSaaS, undefined, retry);
                });
            });
        }
        function startBootstrap(currentSaaS, suitContextConfigKey, retry) {
            window.localStorage.removeItem('selectGroupsStage');
            if (retry) {
                return http.post('/api/v1/office365_emails/retrigger_onboarding').run();
            }
            if (currentSaaS === 'google_mail') {
                dualAppHelper.showGSuiteAuthSuccessModal();
            }
            var bootstrapBody = {
                start_bootstrap: true,
                trigger_readusers: true
            };
            // if (retry) {
            //     bootstrapBody['tenancy-admin-created-at'] = null;
            // }
            var promises = [http.put('/api/v1/apps/' + currentSaaS + '/config').body(bootstrapBody)];
            if (suitContextConfigKey) {
                promises.push(http.put('/api/v1/apps/' + suitContextConfigKey + '/config').body({ groupFilterPopupShown: true }));
            }
            return $q.all(promises);
        }
        var modulesDao = {
            displayUserGroupsFilterModal: function (currentSaas) {
                displayUserGroupsFilterModal(currentSaas);
            },
            getModules: function (includeSecEntityNames) {
                var q = http.get(appApiUrl).preFetch(getTopCategories(), 'topCategories').preFetch(getCategories(), 'appCategories').preFetch(configDao.param('hide_beta_apps'), 'hideBetaApps').preFetch(configDao.param('categories_stack_order_override'), 'categoriesStackOrderOverride').preFetch(configDao.param('categories_app_store_order_override'), 'categoriesAppStoreOrderOverride').preFetch(getOnlyAppsMap(), 'onlyApps').converter(appsConverter, function (preFetches) {
                    return preFetches;
                });
                if (includeSecEntityNames) {
                    q = q.preFetch(modulesDao.getSecEntityConfigs(), 'secEntityConfigs');
                }
                return q;
            },
            getModulesHealCheck: function (modulesList) {
                return http.get('/api/v1/apps/health-check').params({ modules: modulesList.join(',') });
            },
            appStore: function (filter) {
                return modulesDao.getModules().preFetch(http.get('/api/v1/apps/app_store_type'), 'appStoreType').converter(modulesConverter, appStoreOrder).dynamicConverter(function (preFetches) {
                    return appStoreConverter[preFetches.appStoreType.data.app_store_name] || appStoreConverter.all;
                }, { filter: filter });
            },
            cloudApps: function () {
                return modulesDao.getModules().converter(modulesConverter, appStoreOrder).converter(cloudAppsConverter);
            },
            securityMatrix: function () {
                return modulesDao.getModules().preFetch(policyDao.modulesMatrix(), 'modulesMatrix').converter(modulesConverter, securityStackOrder).converter(securityMatrixConverter, function (preFetches) {
                    return preFetches;
                });
            },
            cloudAppsDashboard: function () {
                return modulesDao.getModules(true).converter(modulesConverter, appStoreOrder).converter(cloudAppsDashboardConverter);
            },
            retrieveConfig: function (moduleName, property_name) {
                return http.get('/api/v1/apps/' + moduleName + '/config').params({ property_name: property_name });
            },
            saveConfig: function (appName, data, disableAutoStart) {
                return http.put('/api/v1/apps/' + appName + '/config').params({ not_start: disableAutoStart }).body(data).run();
            },
            operation: function (appName, operation, data) {
                if (operation === 'start') {
                    if ($rootScope.enableMFAPopup && appName === 'office365_emails' && feature.enableMFAOnBoarding) {
                        return dualAppHelper.o365EmailsMFAModal(modulesDao.saveConfig).then(function () {
                            try {
                                return checkGroupFilter(operation, appName).then(function () {
                                    return http.post('/api/v1/apps/' + appName + '/operation/' + operation).body(data).run();
                                });
                            } catch (e) {
                                console.log('Error on checkGroupFilter.', e);
                            }
                        });
                    }
                    try {
                        return checkGroupFilter(operation, appName).then(function () {
                            return http.post('/api/v1/apps/' + appName + '/operation/' + operation).body(data).run();
                        });
                    } catch (e) {
                        console.log('Error on checkGroupFilter.', e);
                    }
                } else {
                    return http.post('/api/v1/apps/' + appName + '/operation/' + operation).body(data).run();
                }
            },
            retryMFAandGroupFilter: function () {
                function process() {
                    try {
                        if (feature.checkpointTheme || feature.sonicwallTheme) {
                            window.localStorage.setItem('selectGroupsStage', 'office365_emails');
                            return displayUserGroupsFilterModal('office365_emails', undefined, true);
                        } else {
                            return startBootstrap('office365_emails', undefined, true);
                        }
                    } catch (e) {
                        console.log('Error on checkGroupFilter.', e);
                    }
                }
                if ($rootScope.enableMFAPopup) {
                    return dualAppHelper.o365EmailsMFAModal(modulesDao.saveConfig).then(function () {
                        process();
                    });
                }
                return process();
            },
            modulesStats: function (entityType) {
                return http.get('/api/v1/apps/statistics').params({ entity_type: entityType }).preFetch(modulesDao.getModules(), 'modules').converter(modulesStatsConverter, function (preFetches) {
                    return $.extend(preFetches, appStoreOrder);
                });
            },
            saveLicense: function (moduleName, data) {
                return http.post('/api/v1/apps/' + moduleName + '/license').body(data).then(function (response) {
                    if (response && response.data && response.data.success === false) {
                        return $q.reject(response);
                    }
                    return response;
                });
            },
            opswatLicense: function () {
                return http.get('/api/v1/apps/opswat_license');
            },
            moduleLabels: function (module, entity) {
                return http.get('/api/v1/apps/' + module + '/entity/' + entity).converter(moduleLabelsConverter, {
                    module: module,
                    entity: entity
                });
            },
            entityInfo: function (module, entity, asPolicy) {
                return http.get('/api/v1/apps/' + module + '/entity/' + entity).params({ same_as_db: asPolicy ? 0 : 1 }).converter(entityInfoConverter, {
                    module: module,
                    entity: entity
                });
            },
            entityInfoRaw: function (module, entity) {
                return http.get('/api/v1/apps/' + module + '/entity/' + entity).params({ same_as_db: 1 }).converter(function (response) {
                    return $q.when(response.data && response.data[entity] || {});
                });
            },
            getAppInfo: function (saas) {
                return http.get(appApiUrl).converter(function (input) {
                    var result = {};
                    var found = _(input.data).find(function (app) {
                        return app.name === saas;
                    });
                    if (found) {
                        result.data = modulePropsToOptions(found);
                    }
                    return $q.when(result);
                });
            },
            authLink: function (saas, params, link) {
                if (link)
                    return http.get(link).params(params);
                return http.get('/api/v1/' + saas + '/auth_link').params(params);
            },
            multiAccounts: function (app) {
                if (app === 'servicenow') {
                    return http.get('/api/v1/servicenow/instances').params({ rnd: Math.random() }).converter(servicenowAccountsConverter);
                }
                return $q.reject({});
            },
            multiAccountAction: function (app, accountId, action) {
                if (app === 'servicenow') {
                    return http.post('/api/v1/servicenow/' + action + '/' + accountId).run();
                }
                return $q.when({});
            },
            multiAccountRemove: function (app, accountId) {
                if (app === 'servicenow') {
                    return http.delete('/api/v1/servicenow/' + accountId).run();
                }
                return $q.when({});
            },
            confirmEmail: function (app, param, code) {
                var body = {};
                body[param] = code;
                return http.put('/api/v1/apps/' + app + '/email_confirm').body(body).run();
            },
            getSecEntityNames: function () {
                return http.get('/api/v1/apps/sec_entity_names');
            },
            getSecEntityConfigs: function () {
                return http.get('/api/v1/apps/sec_entity_configs').onRequestFail(function () {
                    return $q.when(null);
                });
            },
            saasStatus: function (columns, timeoutPromise, fullReport, onlySaas) {
                return saasStatusReportBuilder({
                    columns: columns,
                    timeoutPromise: timeoutPromise,
                    fullReport: fullReport,
                    onlySaas: onlySaas
                });
            },
            learningModeEnable: function (app, targetState) {
                return http.post('/api/v1/apps/' + app + '/learn_mode/' + (targetState ? 'enable' : 'disable')).run();
            },
            adminLicense: function (appName, params) {
                return http.post('/api/v1/apps/' + appName + '/license_adm').body(params).run();
            },
            appsOnly: function () {
                if (appsResultCache) {
                    var deferred = $q.defer();
                    deferred.resolve(appsResultCache);
                    return deferred.promise;
                } else {
                    return http.get(appApiUrl).converter(function (input) {
                        _(input.data).each(function (module) {
                            module.state = {
                                'enabled': 'active',
                                'disabled': 'nonactive'
                            }[module.state] || module.state;
                        });
                        appsResultCache = input;
                        return $q.when(input);
                    });
                }
            },
            authTaskStatus: function (taskId) {
                return http.get('/api/v1/office365_admin/auth_task/' + taskId);
            },
            startBootStrap: function (appName, suitContextConfigKey) {
                startBootstrap(appName, suitContextConfigKey);
            }
        };
        return modulesDao;
    }]);
}());